// extracted by mini-css-extract-plugin
var _1 = "Label_extraPaddingBottom__G0DRK";
var _2 = "Label_label__iXn6U";
var _3 = "Label_paddingBottom__WDgk4";
export { _1 as "extraPaddingBottom", _2 as "label", _3 as "paddingBottom" }
